import { initHeroCarousel } from '../components/hero-carousel.js';
import { initHeroFinance } from '../components/hero-finance.js';
import { initFinanceCalc } from '../components/finance-calc.js';
import { initFuelCalc } from '../components/fuel-calc.js';
import { initBrandGrid } from '../components/brand-grid.js';
import { initBodyTiles } from '../components/body-tiles.js';
import { initSearchBar } from '../components/search-bar.js';
import { initTiltMarquee } from '../components/tilt-marquee.js';

export function initIndexPage() {
  initHeroCarousel();
  initHeroFinance();
  initFinanceCalc();
  initFuelCalc();
  initBrandGrid();
  initBodyTiles();
  initSearchBar();
  initTiltMarquee();

  // The "Cele mai căutate modele" cards are server-rendered curated model
  // cards - do NOT re-render them client-side. The global initCardSliders()
  // and initFavorites() (run in main.js) still enhance the server markup.
}
